import { useStaticQuery, graphql } from "gatsby"
import "normalize.css/normalize.css"
import { Header } from "./Header"
import { Container, Box } from "@theme-ui/components"
import React, { FunctionComponent, ReactNode } from "react"
import { ThemeProvider } from "./ThemeProvider"
import { Stack } from "./Stack"
import { styled } from "../gatsby-theme-stitches/config"

const Footer = styled("footer", {
  position: "fixed",
  bottom: -25,
  width: "100vw",
  left: 0,
  boxShadow: "0 -25px 20px 10px $footer",
})

const Layout: FunctionComponent<{ children: ReactNode }> = ({
  children,
}): JSX.Element => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div>
      <ThemeProvider>
        <Stack space="xxl">
          <Header siteTitle={data.site.siteMetadata.title} />
          <div>
            <main>{children}</main>
            <Footer />
          </div>
        </Stack>
      </ThemeProvider>
    </div>
  )
}

export default Layout
